import Cookies from "js-cookie";

export function getLogoutReducer(state, action) {
	Cookies.remove("mbdo_at");

	return {
		...state,
		isLoggedIn: false,
		accessToken: null,
		accountData: null,
		error: null,
	};
}
